<template>
  <div></div>
</template>

<script>
import { mapActions } from 'vuex';
import { LOGOUT } from '@/store/modules/User/actions';
export default {
  async mounted() {
    const { protocol, hostname, pathname } = window.location;
    const { done } = await this.logout();
    if (done) window.location.assign(`${protocol}//${hostname}${pathname}#/`);
    window.location.reload();
  },
  methods: {
    ...mapActions('user', [LOGOUT]),
  },
};
</script>
